"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateValue = void 0;
/**
 * Formats a given date to double digit format.
 *
 * @param {number} date - The value to be formatted.
 * @returns {string} - The formatted date.
 */
const formatDateValue = (date) => {
    return String(date).padStart(2, "0");
};
exports.formatDateValue = formatDateValue;
